import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { useController } from "react-hook-form";
import { getError } from '../../../utils/FormError';
import { useFormContext } from 'react-hook-form';

const btnStyle = {
  background: '#fff',
  border: '1px solid #b4b4b4',
  padding: '0.375rem 0.75rem',
  cursor: 'pointer',
  color: '#495057',
  fontWeight: 700,
  fontSize: '0.875rem',
  lineHeight: 1.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'background 0.15s',
};

const InputQuantity = ({
  name,
  control,
  validationRules = {}
}) => {
  const { formState: { errors } } = useFormContext();

  const {
    field: { onChange, onBlur, value, ref },
  } = useController({
    name,
    control,
    rules: validationRules,
    defaultValue: 1,
  });

  const error = getError(errors, name);

  const handleChange = (newValue) => {
    onChange({ target: { name, value: newValue } });
  };

  const decrement = () => {
    const numericValue = parseInt(value) || 0;
    if (numericValue > 1) handleChange(numericValue - 1);
  };

  const increment = () => {
    const numericValue = parseInt(value) || 0;
    handleChange(numericValue + 1);
  };

  const handleBlur = () => {
    if (value === '' || value === null || isNaN(value)) {
      handleChange(1);
    }
    if (onBlur) onBlur();
  };

  return (
    <div style={{ display: 'flex', zIndex: 1 }}>
      <input
        type="text"
        name={name}
        className={`form-control fw-bold ${error ? 'is-invalid' : ''}`}
        style={{ borderRadius: '6px 0 0 6px', borderRight: 'none' }}
        value={value ?? ''}
        onChange={(e) => {
          const rawValue = e.target.value;
          if (/^\d*$/.test(rawValue)) {
            handleChange(rawValue === '' ? '' : parseInt(rawValue));
          }
        }}
        onBlur={handleBlur}
        ref={ref}
      />
      <button
        type="button"
        style={{ ...btnStyle, borderLeft: '1px solid #b4b4b4', borderRadius: 0 }}
        onClick={decrement}
        onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
        onMouseLeave={e => e.currentTarget.style.background = '#fff'}
      >
        <FontAwesomeIcon icon={faMinus} />
      </button>
      <button
        type="button"
        style={{ ...btnStyle, borderLeft: 'none', borderRadius: '0 6px 6px 0' }}
        onClick={increment}
        onMouseEnter={e => e.currentTarget.style.background = '#f8f9fa'}
        onMouseLeave={e => e.currentTarget.style.background = '#fff'}
      >
        <FontAwesomeIcon icon={faPlus} />
      </button>
      {error && (
        <div className="invalid-feedback d-block">
          {error.message}
        </div>
      )}
    </div>
  );
};

export default InputQuantity;
